import React from 'react';
import { BaseInstructionScreen, List, InstructionSection } from './BaseInstructionScreen';

const WritingInstructions = ({ onBack, onStart }) => {
  return (
    <BaseInstructionScreen
      title="TOEFL Writing Test"
      icon="✍️"
      gradientStart="#2ecc71"
      gradientEnd="#27ae60"
      bulletColor="#2ecc71"
      onBack={onBack}
      onStart={onStart}
    >
      <InstructionSection>
        <h2>Test Format</h2>
        <List bulletColor="#2ecc71">
          <li>2 writing tasks</li>
          <li>50 minutes total time</li>
          <li>Integrated Task: 20 minutes</li>
          <li>Independent Task: 30 minutes</li>
        </List>
      </InstructionSection>

      <InstructionSection>
        <h2>Task Details</h2>
        <List bulletColor="#2ecc71">
          <li>Integrated Task: Read, listen, then write response</li>
          <li>Independent Task: Essay based on personal experience</li>
          <li>Minimum word count: 150-225 words (Integrated)</li>
          <li>Minimum word count: 300 words (Independent)</li>
        </List>
      </InstructionSection>

      <InstructionSection>
        <h2>Scoring Criteria</h2>
        <List bulletColor="#2ecc71">
          <li>Development and organization of ideas</li>
          <li>Grammar and vocabulary usage</li>
          <li>Accuracy and completeness</li>
          <li>Quality of writing</li>
        </List>
      </InstructionSection>
    </BaseInstructionScreen>
  );
};

export default WritingInstructions; 